import './newsletter.css'
import newsletterTwoShape1 from '../../assets/images/newsletter-two-shape-1.png'
import newsletterTwoShape2 from '../../assets/images/newsletter-two-shape-2.png'
import newsletterTwoImg2 from '../../assets/images/newsletter-two-img-2.png'

const NewsLetter = () => {
    return (
        <div className="newsletter-two-area pb-100">
            <div className="container">
                <div className="newsletter-two-card-item">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="newsletter-two-image">
                                <img src={newsletterTwoImg2} alt="images" />
                                <div className="newsletter-two-shape-bgs10">
                                    <img src={newsletterTwoShape1} alt="images" />
                                </div>
                                <div className="newsletter-two-shape-bg11">
                                    <img src={newsletterTwoShape2} alt="images" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6"  >
                            <div className="single-newsletter-content newsletter-two-content">
                                <div className="section-title section-title-left">
                                    <span className="top-title top-title-two">Our NewsLetter</span>
                                    <h2>Subscribe Newsletter</h2>
                                </div>
                                <div className="subscribe-from">
                                    <form className="newsletter-form" data-toggle="validator" noValidate="true" onSubmit={(e)=>e.preventDefault()}>
                                        <input type="email" className="form-control" placeholder="Enter Your Email" name="EMAIL" required autoComplete="off" />

                                        <button className="default-btn btn-style-three" type="submit">
                                            Subscribe Now
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewsLetter